export default (function (id) {
  return id ? {
    root: "".concat(id, "__root"),
    background: "".concat(id, "__background"),
    arrowContainer: "".concat(id, "__arrow-container"),
    arrowRotator: "".concat(id, "__arrow-rotator"),
    text: "".concat(id, "__text")
  } : {};
});
//# sourceMappingURL=getIds.js.map